// extracted by mini-css-extract-plugin
module.exports = {"juridicalProcess":"JuridicalProcess_juridicalProcess__2xc3P","stage":"JuridicalProcess_stage__3xmcY"};